module.exports = __webpack_public_path__ + "static/media/travel.02e7ba79.png";